import * as React from "react";

export interface ModalDialogProps
{
	title: string;
	open: boolean;
	includeHeader?: boolean;
	dismissWithClick?: boolean;
}

export class ModalDialog extends React.Component<ModalDialogProps, any>
{
	dialog: HTMLElement;

	componentWillUnMount()
	{
		if (this.dialog)
		{
			$(this.dialog).modal("hide");
		}
	}

	render()
	{
		let header: JSX.Element = null;
		let shouldIncludeheader = this.props.includeHeader || (this.props.includeHeader === undefined || this.props.includeHeader === null);
		if (shouldIncludeheader)
		{
			header = <div className="modal-header">
						<h4>
							{this.props.title}
						</h4>
					</div>;
		}
		let backdrop = this.props.dismissWithClick !== null ? (this.props.dismissWithClick ? "true" : "static") : "static";
		return <div ref={(ref: HTMLElement) => this
			.openDialog(ref, this.props.open) } className="modal fade" role="dialog" data-keyboard="false" data-backdrop=
			"static">
				<div className="modal-dialog">
					<div className="modal-content">
							{header}
						{this.props.children}
					</div>
				</div>
			</div>;
	}

	private openDialog(dialogElement: HTMLElement, open: boolean)
	{
		if (!this.dialog)
		{
			this.dialog = dialogElement;
		}
		if (open)
		{
			$(this.dialog).modal("show");
		} else
		{
			$(this.dialog).modal("hide");
		}
	}
}

export interface ModalBodyProps
{
	className?: string;
}
	

export class ModalBody extends React.Component<ModalBodyProps, any>
{
	render()
	{
		let className = this.props.className ? this.props.className : "";
		return <div className={"modal-body " + className }>
					{this.props.children}
				</div>;
	}
}

export interface ModalFooterProps
{
	className?: string;
}
	

export class ModalFooter extends React.Component<ModalFooterProps, any>
{
	render()
	{
		let className = this.props.className ? this.props.className : "";
		return <div className={"modal-footer " + className}>
					{this.props.children}
				</div>;
	}
}


// WEBPACK FOOTER //
// ./src/components/common/ModalDialog.tsx